import React from 'react';
import { FloatingNextBtn } from 'public/assets';
import { css } from '@emotion/react';
import theme from '@styles/theme';

interface IPrevArrowButton {
  onButtonClick: React.MouseEventHandler<HTMLDivElement>;
  isShow: boolean;
}

const NextArrowButton = ({ onButtonClick, isShow }: IPrevArrowButton) => {
  if (!isShow) {
    return null;
  }

  return (
    <FloatingNextBtn
      css={wrapper}
      onClick={onButtonClick}
      width={32}
      height={32}
    />
  );
};

const wrapper = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.95;
  z-index: 2;
  border-radius: 0.25em;
  cursor: pointer;
  right: -1.25rem;

  @media screen and (max-width: ${theme.devices.mobile}) {
    display: none;
  }
`;

export default NextArrowButton;
